/**
 * PLP media component
 *
 * @module product-media
 * @version 2.0.0
 * @extends HTMLElement
 */

class productMediaComponent extends HTMLElement {
	constructor() {
		super();

		this.initialVariantTitle =
			this.getAttribute("data-variant-title").toUpperCase();

		let variantTitle;
		variantTitle = this.initialVariantTitle;

		// Media element.
		this.media = this.querySelector("[data-media]");

		this.initSlider(variantTitle);
	}

	connectedCallback() {
		window.addEventListener("variant-change", (event) => {
			if (event.detail.product.id == parseInt(this.dataset.productMediaId)) {
				this.updateMedia(event.detail.product, event.detail.variant);
			}
		});
	}

	// Initialize the media slider.
	initSlider(variantTitle) {
		this.slider = new Swiper(this.media, {
			preloadImages: true,
			autoHeight: true,
			slidesPerView: "auto",
			pagination: {
				el: ".swiper-media-pagination",
				// dynamicBullets: true,
			},
			// add next and prev button for slider (markup comment #18)
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			loop: false,
			// end add next and prev button for slider
		});

		const initialVariantTitle = this.getAttribute("data-variant-title");
		const productTitle = this.getAttribute("data-product-title");
	}

	preloadImages(images) {
		images.forEach((image) => {
			const img = new Image();
			img.src = image.src;
		});
	}
	

	getCurrentAlt(product, variant) {
		let currentAlt = null;

		if (product.media) {
			for (let image of product.media) {
				if (
					!image.alt ||
					image.alt.toUpperCase() === product.title.toUpperCase()
				) {
					return image.alt || product.title;
				}

				if (variant) {
					const altText = image.alt.toUpperCase();
					const altWords = altText
						.split(" ")
						.filter((word) => word !== "AB_TEST");
					const variantOptions = [
						variant.option1,
						variant.option2,
						variant.option3,
					]
						.filter(Boolean)
						.map((option) =>
							option
								.toUpperCase()
								.replace(/[^a-zA-Z0-9.()]/g, " ")
								.replace(/\s+/g, " ")
								.trim()
						);

					//    console.log("Variant Options:", variantOptions);
					if (
						altWords.every((word) =>
							variantOptions.some((opt) => opt.indexOf(word) !== -1)
						)
					) {
						currentAlt = altText;
						break;
					}
				}
			}
		}

		return currentAlt;
	}

	updateMedia(product, variant) {
		this.preloadImages(product.media);

		const currentAlt = this.getCurrentAlt(product, variant);

		//    console.log("Current Alt:", currentAlt);

		if (currentAlt) {
			const filteredMedia = product.media.filter(
				(image) =>
					(image.alt && image.alt.toUpperCase() === currentAlt) ||
					!image.alt ||
					image.alt.toUpperCase() === product.title.toUpperCase()
			);

			this.setMediaInSlider(filteredMedia);
		} else {
			this.setMediaInSlider(product.media);
		}
		const variantTitle = variant.title.toUpperCase();
	}

	setMediaInSlider(media) {
		const imagesToLoad = media.length;
		let imagesLoaded = 0;

		// Preload all images first
		media.forEach((image) => {
			const img = new Image();
			img.src = image.src;

			img.onload = () => {
				imagesLoaded++;

				// Once all images are loaded, update the Swiper
				if (imagesLoaded === imagesToLoad) {
					this.updateSwiperWithMedia(media);
				}
			};
		});
	}

	updateSwiperWithMedia(media) {
		this.slider.removeAllSlides();

		media.forEach((image, index) => {
			const slide = document.createElement("div");
			slide.className = "swiper-slide";

			const img = document.createElement("img");
			img.src = image.src;
			slide.appendChild(img);

			this.slider.appendSlide(slide);

			// Attach event listener to image click event
			img.addEventListener("click", () => {
				this.openPhotoSwipe(index, media);
			});
		});

		this.slider.update();

		// Set the Swiper pagination to display: block
		const swiperPagination = this.media.querySelector(
			".swiper-media-pagination"
		);
		if (swiperPagination) {
			swiperPagination.style.display = "block";
		}
	}

	/**
	 * Extracts the variant ID from the URL.
	 *
	 * @returns {string|null} The variant ID if it exists, otherwise null.
	 */
	getVariantIdFromURL() {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get("variant");
	}
}

if (!customElements.get("component-product-media")) {
	customElements.define("component-product-media", productMediaComponent);
}
